import React, { useState, useEffect } from 'react';
import { ModalContainer, ModalContent, Form, Label, Button, Input, Select } from './StyledComponents';
import AssetAvailabilityFields from './AssetAvailabilityFields';

const getRandomColor = () =>
  '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');

const AddAccountModal = ({ isOpen, onClose, onSave, accountType }) => {
  const [name, setName] = useState('');
  const [balance, setBalance] = useState(0);
  const [color, setColor] = useState(getRandomColor());
  const [type, setType] = useState(accountType || 'Bank');
  const [availabilityType, setAvailabilityType] = useState('now');
  const [availableFromAge, setAvailableFromAge] = useState(60);
  const [availableFromDate, setAvailableFromDate] = useState('');

  useEffect(() => {
    setType(accountType || 'Bank');
  }, [accountType]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const availability = type === 'Asset'
      ? {
          availabilityType,
          availableFromAge:
            availabilityType === 'age' ? parseInt(availableFromAge, 10) : null,
          availableFromDate: availabilityType === 'date' ? availableFromDate : null,
        }
      : {
          availabilityType: 'now',
          availableFromAge: null,
          availableFromDate: null,
        };
    onSave({
      name,
      balance: parseFloat(balance),
      type,
      color,
      archived: false,
      ...availability,
    });
  };

  if (!isOpen) return null;

  return (
    <ModalContainer>
      <ModalContent>
        <Form onSubmit={handleSubmit}>
          <Label>Name:</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
          <Label>Balance:</Label>
          <Input type="number" step="0.01" value={balance} onChange={(e) => setBalance(e.target.value)} />
          {!accountType && (
            <>
              <Label>Type:</Label>
              <Select value={type} onChange={(e) => setType(e.target.value)}>
                <option value="Bank">Bank</option>
                <option value="Loan">Loan</option>
                <option value="Asset">Asset</option>
                <option value="Income">Income</option>
                <option value="Expense">Expense</option>
              </Select>
            </>
          )}
          {type === 'Asset' && (
            <AssetAvailabilityFields
              availabilityType={availabilityType}
              availableFromAge={availableFromAge}
              availableFromDate={availableFromDate}
              onAvailabilityTypeChange={(e) => setAvailabilityType(e.target.value)}
              onAvailableFromAgeChange={(e) => setAvailableFromAge(e.target.value)}
              onAvailableFromDateChange={(e) => setAvailableFromDate(e.target.value)}
            />
          )}
          <Label>Colour:</Label>
          <Input type="color" value={color} onChange={(e) => setColor(e.target.value)} />
          <Button type="submit">Add Account</Button>
          <Button onClick={onClose}>Close</Button>
        </Form>
      </ModalContent>
    </ModalContainer>
  );
};

export default AddAccountModal;
